import { render, staticRenderFns } from "./OtherLegalDocs.vue?vue&type=template&id=4bd499ad&scoped=true"
import script from "./OtherLegalDocs.vue?vue&type=script&lang=js"
export * from "./OtherLegalDocs.vue?vue&type=script&lang=js"
import style0 from "./OtherLegalDocs.vue?vue&type=style&index=0&id=4bd499ad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd499ad",
  null
  
)

export default component.exports